<template>
<div class="chapter">
<div class="inner_page">
<div class="ch1" id="ch1-1">
<p class="centerImage"><img alt="images" id="img6" src="images/img6.jpg"/></p>
<p class="caption"><span class="bolditalic">Bust of Thucydides</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_ch11.vue?72cc4b6c